import React from 'react'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import { StyleSheet } from 'react-native'
import _ from "lodash"
import { GraphBookingDays, GraphBookTime } from 'components/management/molecules/graphs'
import GraphDateRange from 'components/atoms/GraphDateRange'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const ViewUsage = ({ dateRange }) => {
	
	const graphs = [
		<GraphBookingDays
			dateRange={ dateRange }
		/>,
		<GraphBookTime
			dateRange={ dateRange }
		/>,
	]
	
	return (
		<Grid>
			<Container>
				<Row>
					<Column>
						<GraphDateRange containerStyle={ styles.graphDateRangeMarginTop0 } />
					</Column>
				</Row>
				
				<VStack
					space={ ThemedValues.stackSpace }>
				
					{ _.map( graphs, graph => {
						return (
							<Row style={ styles.chart }>
								<Column
									span={ 12 }>

									{ graph }
								</Column>
							</Row>
						);
					})}
				</VStack>
			</Container>
		</Grid>
	)
}

const styles = StyleSheet.create({
	graphDateRangeMarginTop0: {
		marginTop: 0,
	},
	chart: {
		marginBottom: 10
	}
});

export default ViewUsage
